import { useEffect, useRef, useState } from "react";
import { Mic, MicOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

// Voice input usando Web Speech API. Quando suportado, transcreve e envia evento global.
declare global {
  interface Window {
    webkitSpeechRecognition?: any;
    SpeechRecognition?: any;
  }
}

export function VoiceButton() {
  const [listening, setListening] = useState(false);
  const recRef = useRef<any>(null);

  useEffect(() => {
    const onToggle = () => toggle();
    window.addEventListener("neural-action", (e: any) => {
      if (e.detail === "voice-toggle") onToggle();
    });
    return () => {};
  }, [listening]);

  const toggle = () => {
    const SR = window.SpeechRecognition ?? window.webkitSpeechRecognition;
    if (!SR) {
      toast.error("Voice not supported in this browser. Try Chrome/Edge.");
      return;
    }
    if (listening) {
      recRef.current?.stop();
      setListening(false);
      return;
    }
    const r = new SR();
    r.lang = navigator.language || "en-US";
    r.continuous = false;
    r.interimResults = true;
    r.onresult = (ev: any) => {
      const last = ev.results[ev.results.length - 1];
      const text = last[0].transcript as string;
      if (last.isFinal) {
        window.dispatchEvent(new CustomEvent("neural-voice", { detail: text }));
        toast.success(`Voice: "${text}"`);
      }
    };
    r.onerror = () => setListening(false);
    r.onend = () => setListening(false);
    r.start();
    recRef.current = r;
    setListening(true);
    toast("🎙️ Voice God Mode active — speak now");
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      className={`h-9 w-9 ${listening ? "text-accent shadow-glow-magenta" : ""}`}
      title="Voice God Mode (⌘+. or click)"
    >
      {listening ? <Mic className="w-4 h-4 animate-pulse" /> : <MicOff className="w-4 h-4" />}
    </Button>
  );
}
